export default "__VITE_ASSET__B29lDKOr__"